import { useEffect, useRef, useState } from 'react';

/**
 * 뷰포트 진입 시 active.
 * once=false(기본): 아래로 벗어나면 리셋, 위로 스크롤해 요소가 뷰포트 위로 벗어난 경우는 active 유지.
 * once=true: 한 번 active 되면 리셋하지 않음.
 */
export function useScrollActive<T extends HTMLElement = HTMLElement>(
  threshold = 0.3,
  rootMargin = '0px 0px -20% 0px',
  once = false,
) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else if (!once && entry.boundingClientRect.top > 0) {
          setInView(false);
        }
      },
      { threshold, rootMargin },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin, once]);

  return [ref, inView] as const;
}
